const Email = ({ customer }) => {
  if (!customer.emails || customer.emails.length === 0) {
    return null;
  }
  return <>{customer.emails[0].email}</>;
};

export default Email;
